<template>
  <div>
    <div
      v-for="r in sortedReadings"
      :key="r.id || r.recordedAt"
      class="d-flex justify-content-between align-items-center py-1 border-bottom"
    >
      <!-- Edit mode -->
      <template v-if="editingId === r.id">
        <input v-model="editValue" type="text" inputmode="decimal" class="form-control form-control-sm me-1" style="max-width: 70px;" />
        <input v-model="editDate" type="date" class="form-control form-control-sm me-1" />
        <button class="btn btn-sm btn-success py-0 px-1" @click="saveEdit(r)">
          <i class="material-icons" style="font-size: 16px; vertical-align: middle;">check</i>
        </button>
        <button class="btn btn-sm btn-secondary py-0 px-1 ms-1" @click="cancelEdit">
          <i class="material-icons" style="font-size: 16px; vertical-align: middle;">close</i>
        </button>
      </template>

      <!-- Display mode -->
      <template v-else>
        <small>{{ formatDate(r.recordedAt) }}</small>
        <small class="fw-bold">{{ r[valueField].toFixed(1) }}{{ unit }}</small>
        <span class="text-nowrap">
          <button class="btn btn-sm btn-link py-0 px-1 text-secondary" @click="startEdit(r)">
            <i class="material-icons" style="font-size: 16px; vertical-align: middle;">edit</i>
          </button>
          <button class="btn btn-sm btn-link py-0 px-1 text-danger" @click="$emit('delete', { id: r.id })">
            <i class="material-icons" style="font-size: 16px; vertical-align: middle;">delete</i>
          </button>
        </span>
      </template>
    </div>
    <small v-if="!sortedReadings.length" class="text-muted">{{ $t('golf.noRecords') }}</small>
  </div>
</template>

<script>
const CM_PER_FOOT = 30.48;

export default {
  props: {
    readings: { type: Array, default: () => [] },
    // Field on each reading holding the stored value (always feet / liters)
    valueField: { type: String, required: true },
    // Suffix shown next to the displayed value
    unit: { type: String, default: '' },
    // When true the edit input is in centimetres and converted to feet on save
    editInCm: { type: Boolean, default: false },
    limit: { type: Number, default: 5 },
  },
  emits: ['update', 'delete'],
  data() {
    return {
      editingId: null,
      editValue: null,
      editDate: null,
    };
  },
  computed: {
    sortedReadings() {
      return [...this.readings]
        .sort((a, b) => new Date(b.recordedAt) - new Date(a.recordedAt))
        .slice(0, this.limit);
    },
  },
  methods: {
    startEdit(r) {
      this.editingId = r.id;
      this.editDate = new Date(r.recordedAt).toISOString().slice(0, 10);
      const stored = r[this.valueField];
      this.editValue = (this.editInCm ? stored * CM_PER_FOOT : stored).toFixed(1);
    },
    cancelEdit() {
      this.editingId = null;
      this.editValue = null;
      this.editDate = null;
    },
    saveEdit(r) {
      let value = parseFloat(this.editValue);
      if (!value) return;
      if (this.editInCm) value = value / CM_PER_FOOT;
      this.$emit('update', { id: r.id, value, date: this.editDate });
      this.cancelEdit();
    },
    formatDate(dateStr) {
      return new Date(dateStr).toLocaleDateString('is-IS', { day: '2-digit', month: '2-digit' });
    },
  },
};
</script>
